// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"d8600ac06ab3fcf186ae","655":"c0ef434cffec7759467f"}[chunkId] + ".js";
};